
export default class ProductGrid {
    static init() {
        const grid = document.getElementById('jsProductGrid');
        const trigger = document.getElementById('jsProductGridShowAll');

        if (trigger && grid) {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                grid.classList.toggle('product-grid--open');
                trigger.classList.toggle('link--product-grid-open');
            });
        }
    }
}